
import React from "react";
import { ShieldCheck, Search, CreditCard } from "lucide-react";
import { motion } from "framer-motion";

const UscoreAdvertisement = () => {
  return (
    <div className="bg-gradient-to-br from-slate-900 to-slate-800 rounded-xl overflow-hidden shadow-xl">
      <div className="container mx-auto px-4 py-8 md:py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
          {/* Left content - Text */}
          <div className="text-white space-y-6">
            <div className="flex items-center gap-2 mb-4">
              <div className="h-10 w-10 flex items-center justify-center rounded-full bg-gradient-to-r from-green-400 via-yellow-300 to-orange-500">
                <span className="font-bold text-slate-900">u</span>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold">uScore</h2>
            </div>
            
            <h3 className="text-xl md:text-2xl font-semibold">
              Tarkista luottopisteesi ilmaiseksi
            </h3>
            
            <p className="text-slate-300">
              Tietävätkö pankit enemmän sinusta kuin sinä itse? Tarkista luottopisteesi 
              ilmaiseksi ja ymmärrä paremmin taloudellinen asemasi.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex items-start gap-3">
                <ShieldCheck className="h-6 w-6 text-green-400 flex-shrink-0 mt-1" />
                <div>
                  <p className="font-medium">Turvallinen</p>
                  <p className="text-sm text-slate-400">Tunnistautuminen verkkopankkitunnuksilla</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <Search className="h-6 w-6 text-yellow-300 flex-shrink-0 mt-1" />
                <div>
                  <p className="font-medium">Nopea</p>
                  <p className="text-sm text-slate-400">Tulokset vain 15 sekunnissa</p>
                </div>
              </div>
            </div>
            
            <div className="pt-3">
              <a 
                href="https://go.adt212.net/t/t?a=1796594173&as=1854031059&t=2&tk=1" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block bg-gradient-to-r from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 text-white px-6 py-3 rounded-lg font-medium transition-all shadow-lg hover:shadow-xl"
              >
                Tarkista pisteesi nyt
              </a>
            </div>
          </div>
          
          {/* Right content - Credit score visualization */}
          <div className="flex justify-center">
            <motion.div 
              className="relative"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.5 }}
              viewport={{ once: true }}
            >
              <div className="bg-slate-800 rounded-full w-64 h-64 md:w-72 md:h-72 flex items-center justify-center relative">
                <div className="absolute w-full h-full rounded-full">
                  {/* Circular progress bar */}
                  <svg className="w-full h-full" viewBox="0 0 100 100">
                    <circle 
                      cx="50" cy="50" r="45" 
                      fill="none" 
                      stroke="#2a3a4a" 
                      strokeWidth="8"
                    />
                    <circle 
                      cx="50" cy="50" r="45" 
                      fill="none" 
                      stroke="url(#scoreGradient)" 
                      strokeWidth="8"
                      strokeLinecap="round"
                      strokeDasharray="282.7"
                      strokeDashoffset="60"
                      transform="rotate(-90 50 50)"
                    />
                    <defs>
                      <linearGradient id="scoreGradient" x1="0%" y1="0%" x2="100%" y2="0%">
                        <stop offset="0%" stopColor="#4ade80" />
                        <stop offset="50%" stopColor="#fbbf24" />
                        <stop offset="100%" stopColor="#f43f5e" />
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                
                <div className="text-center z-10">
                  <p className="text-slate-300 text-sm font-medium">Luottopisteytys</p>
                  <div className="flex items-end justify-center">
                    <span className="text-5xl font-bold text-white">79</span>
                    <span className="text-slate-400 mb-1 ml-1">/100</span>
                  </div>
                  <p className="text-green-400 text-sm mt-1">Korkea maksukyky</p>
                </div>
              </div>
              
              {/* Credit card icon positioned on the edge */}
              <div className="absolute -bottom-3 -right-3 bg-slate-700 rounded-full p-3 shadow-lg border-4 border-slate-900">
                <CreditCard className="h-8 w-8 text-slate-300" />
              </div>
            </motion.div>
          </div>
        </div>
        
        <div className="mt-6 text-center text-xs text-slate-500">
          uScore auttaa sinua ymmärtämään luottokelpoisuutesi ja mahdollisuutesi saada parempia lainatarjouksia
        </div>
      </div>
    </div>
  );
};

export default UscoreAdvertisement;
